import { useState } from 'react'
import { Pagination } from '../molecules'
import { ManagerRatingsFilters, ManagerRatingsListTable } from '../organism'
import {
  ManagerRatingsReportFilterInput,
  OrderDirectionOption,
  PageSizeOption,
  useGetManagerRatingsReportQuery,
} from '@/graphql/generated'
import { useUserLanguage } from '@/customHooks'
import textsData from '@/textData/reportTexts.json'

const initialFilters: ManagerRatingsReportFilterInput = {
  month: null,
  orderDirection: OrderDirectionOption.Desc,
  pageSize: PageSizeOption.TwentyFive,
  page: null,
  ratingValue: null,
  search: null,
}

export const ManagerRatingsReportPage = () => {
  const userLanguage = useUserLanguage()
  const texts = (userLanguage === 'es' ? textsData.es : textsData.en).managerRatingsReport
  const [currentPage, setCurrentPage] = useState(1)
  const [filters, setFilters] = useState<ManagerRatingsReportFilterInput>(initialFilters)

  const handleFilterChange = (newFilters: ManagerRatingsReportFilterInput) => {
    setFilters(newFilters)
    setCurrentPage(1)
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    setFilters({ ...filters, page: page.toString() })
  }

  const { data } = useGetManagerRatingsReportQuery({
    variables: {
      filterInput: {
        ...filters,
        page: currentPage.toString(),
      },
    },
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  })

  const currentDataCount = data?.managerRatingsReport?.items?.length || 0
  const totalPages = data?.managerRatingsReport?.pagination?.totalPages || 1
  const showPagination = currentDataCount > 0

  return (
    <div className="w-full px-4 md:px-6 space-y-6">
      <h2 className="text-xl md:text-2xl font-semibold">{texts.title}</h2>
      <div>
        <ManagerRatingsFilters
          filters={filters}
          onFilterChange={handleFilterChange}
        />
      </div>
      <div>
        <ManagerRatingsListTable
          filters={{
            ...filters,
            page: currentPage.toString(),
          }}
        />
      </div>
      {showPagination && (
        <div className="pt-2">
          <Pagination
            currentPage={currentPage}
            onPageChange={handlePageChange}
            currentDataCount={currentDataCount}
            pageSize={filters.pageSize || null}
            totalPages={totalPages}
          />
        </div>
      )}
    </div>
  )
}
